import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { SorareLogo } from 'atoms/icons/SorareLogo';
import { Container } from 'atoms/layout/Container';
import { SBHorizontal } from 'atoms/layout/flex';
import SmallerStarBall from 'atoms/navigation/SmallerStarBall';
import { VerticalDivider } from 'atoms/ui/Divider';
import { LANDING } from 'constants/__generated__/routes';
import { useConnectionContext } from 'contexts/connection';
import useScreenSize from 'hooks/device/useScreenSize';
import { glossary } from 'lib/glossary';

const Wrapper = styled(SBHorizontal).attrs({ gap: 0 })`
  height: 80px;
  padding: var(--double-unit) 0;
  border-bottom: 1px solid var(--c-static-neutral-400);
`;

const Actions = styled.div`
  display: flex;
  gap: var(--unit);
`;

const Logo = styled(Link)`
  display: flex;
  gap: var(--unit);
  align-items: center;
`;

interface Props {
  title: string;
  logo?: ReactNode;
  hideSorareLogo?: boolean;
}

const LoggedOutAppBarLanding = ({ title, logo, hideSorareLogo }: Props) => {
  const { signIn, signUp } = useConnectionContext();
  const { up: isTablet } = useScreenSize('tablet');

  return (
    <Container>
      <Wrapper>
        <Logo to={LANDING} title={title}>
          {(!hideSorareLogo || !isTablet) && <SmallerStarBall />}
          {isTablet && (
            <>
              {!hideSorareLogo && (
                <>
                  <SorareLogo />
                  {logo && <VerticalDivider />}
                </>
              )}
              {logo}
            </>
          )}
        </Logo>
        <Actions>
          <Button size="medium" color="secondary" onClick={signUp}>
            <FormattedMessage {...glossary.signup} />
          </Button>
          <Button size="medium" color="transparent" onClick={signIn}>
            <FormattedMessage {...glossary.signin} />
          </Button>
        </Actions>
      </Wrapper>
    </Container>
  );
};

export default LoggedOutAppBarLanding;
